// Shared component styles. Preserve selector order, style values, and caller overrides.
import { TABLE_CHECKBOX_SIZE } from "../../utils/checkboxIcons";
import { pillButtonInteractiveSx } from "./buttonStyles";
export const DEFAULT_SELECTION_COLUMN_WIDTH = 44;
export const DEFAULT_SELECTION_COLUMN_INSET_PX = 22;
export const DEFAULT_SELECTION_HEADER_PADDING_Y = 1.1;
export const DEFAULT_SELECTION_BODY_PADDING_Y = 1.25;
export const resultsFilterChipSx = {
  height: 28,
  maxWidth: "100%",
  borderRadius: "999px",
  backgroundColor: "#EAF2FF",
  color: "#3451F4",
  fontWeight: 500,
  fontSize: 13,
  fontFamily: "Be Vietnam Pro",
  "& .MuiChip-label": {
    px: 1.4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  "& .MuiChip-deleteIcon": {
    color: "#94A3B8",
    fontSize: 18,
    mr: 0.5,
    "&:hover": {
      color: "#3451F4"
    }
  }
};
export const tableStyles = {
  checkedBox: () => ({
    width: TABLE_CHECKBOX_SIZE,
    height: TABLE_CHECKBOX_SIZE,
    flexShrink: 0,
    borderRadius: "4px",
    border: "1px solid #9C4FFF",
    backgroundColor: "#9C4FFF",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  checkmark: () => ({
    width: 4,
    height: 7,
    borderRight: "1.5px solid #FFFFFF",
    borderBottom: "1.5px solid #FFFFFF",
    transform: "rotate(45deg) translate(-0.5px, -0.5px)",
    transformOrigin: "center",
    boxSizing: "border-box"
  }),
  actionCellInline: ({
    columns,
    index,
    cell
  }) => columns[index]?.id === "actions" ? {
    ...(cell.props.style || {}),
    textAlign: "right"
  } : cell.props.style,
  actionCell: ({
    columns,
    index,
    cell
  }) => columns[index]?.id === "actions" ? [cell.props.sx, {
    textAlign: "right !important",
    "& > .MuiIconButton-root": {
      ml: "auto",
      mr: 0
    }
  }] : cell.props.sx,
  headerSelectionCell: ({
    resolvedSelectionColumnWidth,
    resolvedSelectionColumnInsetPx
  }) => ({
    width: resolvedSelectionColumnWidth,
    minWidth: resolvedSelectionColumnWidth,
    maxWidth: resolvedSelectionColumnWidth,
    pl: `${resolvedSelectionColumnInsetPx}px !important`,
    pr: "0 !important",
    pt: DEFAULT_SELECTION_HEADER_PADDING_Y,
    pb: DEFAULT_SELECTION_HEADER_PADDING_Y,
    verticalAlign: "middle",
    boxSizing: "border-box",
    "& .MuiCheckbox-root": {
      p: 0,
      width: TABLE_CHECKBOX_SIZE,
      height: TABLE_CHECKBOX_SIZE,
      minWidth: TABLE_CHECKBOX_SIZE,
      minHeight: TABLE_CHECKBOX_SIZE,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }),
  bodySelectionCell: ({
    resolvedSelectionColumnWidth,
    resolvedSelectionColumnInsetPx
  }) => ({
    width: resolvedSelectionColumnWidth,
    minWidth: resolvedSelectionColumnWidth,
    maxWidth: resolvedSelectionColumnWidth,
    pl: `${resolvedSelectionColumnInsetPx}px !important`,
    pr: "0 !important",
    pt: DEFAULT_SELECTION_BODY_PADDING_Y,
    pb: DEFAULT_SELECTION_BODY_PADDING_Y,
    verticalAlign: "middle",
    boxSizing: "border-box",
    "& .MuiCheckbox-root": {
      p: 0,
      width: TABLE_CHECKBOX_SIZE,
      height: TABLE_CHECKBOX_SIZE,
      minWidth: TABLE_CHECKBOX_SIZE,
      minHeight: TABLE_CHECKBOX_SIZE,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }),
  headerSelectionInline: ({
    resolvedSelectionColumnWidth,
    resolvedSelectionColumnInsetPx,
    selectionCellStyle
  }) => ({
    width: resolvedSelectionColumnWidth,
    minWidth: resolvedSelectionColumnWidth,
    maxWidth: resolvedSelectionColumnWidth,
    paddingLeft: `${resolvedSelectionColumnInsetPx}px`,
    paddingRight: "0px",
    paddingTop: `${DEFAULT_SELECTION_HEADER_PADDING_Y * 8}px`,
    paddingBottom: `${DEFAULT_SELECTION_HEADER_PADDING_Y * 8}px`,
    verticalAlign: "middle",
    boxSizing: "border-box",
    ...(selectionCellStyle || {})
  }),
  bodySelectionInline: ({
    resolvedSelectionColumnWidth,
    resolvedSelectionColumnInsetPx,
    selectionCellStyle
  }) => ({
    width: resolvedSelectionColumnWidth,
    minWidth: resolvedSelectionColumnWidth,
    maxWidth: resolvedSelectionColumnWidth,
    paddingLeft: `${resolvedSelectionColumnInsetPx}px`,
    paddingRight: "0px",
    paddingTop: `${DEFAULT_SELECTION_BODY_PADDING_Y * 8}px`,
    paddingBottom: `${DEFAULT_SELECTION_BODY_PADDING_Y * 8}px`,
    verticalAlign: "middle",
    boxSizing: "border-box",
    ...(selectionCellStyle || {})
  }),
  matchActionOverride: ({
    existingRight
  }) => ({
    ...(existingRight?.sx || {})
  }),
  toolbarContent: () => ({
    minWidth: 0
  }),
  matchButton: () => [pillButtonInteractiveSx, {
    textTransform: "none",
    borderRadius: 999,
    backgroundColor: "#9C4FFF",
    color: "#fff",
    height: 44,
    minHeight: 44,
    px: 3,
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#9C4FFF",
      boxShadow: "none"
    },
    "& .MuiButton-startIcon": {
      marginLeft: 0,
      marginRight: "12px"
    }
  }],
  root: ({
    rootSx
  }) => [{
    fontFamily: "'Be Vietnam Pro', sans-serif",
    "& .MuiTypography-root, & .MuiTableCell-root, & .MuiInputBase-root, & .MuiButton-root": {
      fontFamily: "'Be Vietnam Pro', sans-serif"
    }
  }, rootSx],
  resultsBar : ({
    isReferenceVariant
  }) => isReferenceVariant ? {
    pt: 0.5,
    pb: 0.75,
    "& .MuiTypography-root": {
      fontSize: 10.5,
      color: "#667085"
    }
  } : undefined,
  resultsSummary: ({
    resultsToolbarTargetId
  }) => ({
    minWidth: 0,
    flex: 1,
    // When the toolbar is hosted by TopListHeaderBar, cancel its
    // own horizontal padding on the left only. This keeps Results
    // aligned with the title without moving the right controls.
    ...(resultsToolbarTargetId ? {
      ml: -2
    } : {})
  }),
  resultsCount: () => ({
    fontWeight: "inherit"
  }),
  filterChips: () => ({
    minWidth: 0
  }),
  filterControls: () => ({
    ml: "auto"
  }),
  mobilePageSize: () => ({
    display: {
      xs: "flex",
      sm: "none"
    },
    minWidth: 72,
    height: 40,
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    color: "#344054",
    fontSize: 13
  }),
  desktopPageSize: () => ({
    display: {
      xs: "none",
      sm: "block"
    },
    minWidth: 72
  }),
  pageSizeSelect: ({
    isReferenceVariant
  }) => ({
    borderRadius: isReferenceVariant ? "6px !important" : "8px !important",
    fontSize: isReferenceVariant ? 10.5 : 13,
    height: isReferenceVariant ? 30 : undefined,
    color: "#344054",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E4E7EC"
    },
    "& .MuiSelect-select": {
      py: isReferenceVariant ? 0.35 : 0.5,
      pl: isReferenceVariant ? 1.2 : 1.5,
      pr: 3
    }
  }),
  topPreviousButton: ({
    isReferenceVariant
  }) => ({
    minWidth: isReferenceVariant ? 28 : 32,
    height: isReferenceVariant ? 28 : undefined,
    px: 1,
    touchAction: "manipulation",
    borderRadius: "8px !important",
    border: "1px solid #E4E7EC",
    color: "#98A2B3",
    textTransform: "none",
    "&.Mui-disabled": {
      borderColor: "#E4E7EC",
      color: "#D1D5DB"
    }
  }),
  topPreviousIcon: ({
    isReferenceVariant
  }) => ({
    fontSize: isReferenceVariant ? 12 : 14
  }),
  topNextButton: ({
    isReferenceVariant
  }) => ({
    minWidth: isReferenceVariant ? 28 : 32,
    height: isReferenceVariant ? 28 : undefined,
    px: 1,
    touchAction: "manipulation",
    borderRadius: "8px !important",
    border: "1px solid #E4E7EC",
    color: isReferenceVariant ? "#9C4FFF" : "#6B7280",
    textTransform: "none",
    "&.Mui-disabled": {
      borderColor: "#E4E7EC",
      color: "#D1D5DB"
    }
  }),
  topNextIcon: ({
    isReferenceVariant
  }) => ({
    fontSize: isReferenceVariant ? 12 : 14
  }),
  topBulkActions: ({
    isReferenceVariant,
    topBulkActionsWrapperSx
  }) => ({
    px: isReferenceVariant ? 0 : "10px",
    // The tab bar already supplies the divider. A second border here
    // made table views with bulk actions look thicker than views such
    // as Recruiting Pipeline, which has filters below its tabs.
    borderTop: "none",
    borderBottom: isReferenceVariant ? "1px solid #84CAFF" : "none",
    paddingTop: isReferenceVariant ? 0 : "10px",
    paddingBottom: isReferenceVariant ? 0 : "10px",
    mb: 0,
    ...(topBulkActionsWrapperSx || {})
  }),
  mobileSortBar: () => ({
    display: {
      xs: "flex",
      sm: "none"
    },
    px: 1,
    pb: 1
  }),
  mobileSortLabel: () => ({
    whiteSpace: "nowrap"
  }),
  mobileSortField: () => ({
    minWidth: 0,
    flex: 1
  }),
  mobileSortSelect: () => ({
    fontSize: 12,
    height: 34,
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E4E7EC"
    },
    "& .MuiSelect-select": {
      py: 0.5
    }
  }),
  mobileSortDirection: () => ({
    width: 34,
    height: 34,
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    color: "#667085"
  }),
  pageSizeMenu: () => ({
    backgroundColor: "#9C4FFF",
    color: "#FFFFFF",
    borderRadius: 0,
    fontFamily: "Be Vietnam Pro",
    fontSize: 12,
    fontWeight: 300,
    lineHeight: 1.2,
    px: 1.25,
    py: 0.55
  }),
  tableContainer: ({
    tableContainerSx
  }) => [{
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto"
  }, tableContainerSx],
  table: ({
    isReferenceVariant,
    isCompanyStandardVariant,
    tableSx
  }) => [{
    width: "100%",
    maxWidth: "100%",
    tableLayout: "fixed",
    "& .MuiTableCell-root": {
      minWidth: "0 !important",
      maxWidth: "100%",
      overflow: "hidden",
      overflowWrap: "normal",
      wordBreak: "normal",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    },
    "& .MuiTableCell-root > *": {
      minWidth: 0,
      maxWidth: "100%"
    },
    "& .MuiTableSortLabel-root": {
      maxWidth: "100%",
      alignItems: "flex-start",
      whiteSpace: "normal"
    },
    "& .MuiTableSortLabel-root .MuiTableSortLabel-icon": {
      flex: "0 0 auto",
      mt: "2px"
    },
    "& .MuiTableCell-root .MuiTypography-root:not([data-company-text])": {
      overflowWrap: "normal",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "@media (max-width:1200px)": {
      display: "block",
      "& colgroup": {
        display: "none"
      },
      "& .MuiTableHead-root": {
        display: "none"
      },
      "& .MuiTableBody-root": {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: 1,
        width: "100%"
      },
      "& .MuiTableBody-root .MuiTableRow-root": {
        display: "block",
        width: "100%",
        mb: 0,
        position: "relative",
        pt: 5,
        border: "1px solid #E4E7EC",
        borderRadius: 1.5,
        overflow: "hidden"
      },
      "& .MuiTableBody-root .MuiTableCell-root": {
        display: "block",
        width: "100% !important",
        borderBottom: "1px solid #EAECF0"
      },
      "& .MuiTableBody-root .MuiTableCell-root::before": {
        content: "attr(data-column-label)",
        display: "block",
        color: "#667085",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.3,
        marginBottom: "10px",
        overflowWrap: "anywhere"
      },
      "& .MuiTableBody-root .MuiTableCell-root[data-column-id='actions']": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1
      },
      "& .MuiTableBody-root .MuiTableCell-root[data-column-id='actions']::before": {
        marginBottom: 0
      },
      "& .MuiTableBody-root .MuiTableCell-root[data-column-id='actions'] > *": {
        marginLeft: "auto"
      },
      "& .MuiTableBody-root .MuiTableCell-root:last-child": {
        borderBottom: "none"
      },
      "& .MuiTableBody-root .MuiTableCell-root.generic-table-selection-cell": {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        minHeight: 35,
        borderBottom: "none"
      },
      "& .MuiTableBody-root .MuiTableCell-root.generic-table-selection-cell .MuiCheckbox-root": {
        marginLeft: "auto"
      },
      "& .MuiTableBody-root .MuiTableCell-root.generic-table-selection-cell::before": {
        display: "none"
      },
      "& .MuiTableHead-root .MuiTableCell-root, & .MuiTableBody-root .MuiTableCell-root": {
        px: 0.75,
        py: 1.25,
        fontSize: 11,
        lineHeight: 1.3
      },
      "& .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root": {
        borderLeft: "1px solid #E4E7EC",
        borderRight: "1px solid #E4E7EC"
      },
      "& .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root:first-of-type": {
        borderTop: "1px solid #E4E7EC",
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6
      },
      "& .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root:last-of-type": {
        borderBottom: "1px solid #E4E7EC",
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6
      },
      // Keep the selection control in the card's upper-right
      // corner, without giving it a separate, full-width row.
      "& .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root.generic-table-selection-cell": {
        position: "absolute",
        top: 8,
        right: 8,
        zIndex: 1,
        display: "flex",
        width: "auto !important",
        minWidth: 0,
        minHeight: 0,
        p: "0 !important",
        border: "none !important"
      },
      "& .MuiTableHead-root .MuiTableCell-root": {
        fontSize: 10
      }
    }
  }, isReferenceVariant ? {
    "& .MuiTableHead-root .MuiTableRow-root": {
      borderTop: "none",
      borderBottom: "1px solid #EAECF0"
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      px: 1.25,
      py: 1.1,
      borderBottom: "1px solid #EAECF0",
      color: "#667085",
      fontSize: 10,
      fontWeight: 400,
      whiteSpace: "normal"
    },
    "& .MuiTableHead-root .MuiCheckbox-root": {
      p: 0,
      width: TABLE_CHECKBOX_SIZE,
      height: TABLE_CHECKBOX_SIZE,
      boxSizing: "border-box"
    },
    "& .MuiTableBody-root .MuiTableRow-root": {
      height: 52
    },
    // The generic mobile layout turns table rows into cards.
    // Keep reference rows unconstrained there; the desktop
    // density height otherwise clips every cell after the
    // selection checkbox.
    "@media (max-width:1200px)": {
      "& .MuiTableBody-root .MuiTableRow-root": {
        height: "auto",
        minHeight: 0
      }
    },
    "@media (max-width:600px)": {
      "& .MuiTableBody-root": {
        gridTemplateColumns: "1fr"
      }
    },
    "& .MuiTableBody-root .MuiTableRow-root:hover": {
      backgroundColor: "#FCFCFD"
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      px: 1.25,
      py: 1.1,
      borderBottom: "1px solid #F2F4F7",
      color: "#344054",
      fontSize: 11,
      fontWeight: 400,
      verticalAlign: "middle"
    },
    "& .MuiTableBody-root .MuiCheckbox-root": {
      p: 0,
      width: TABLE_CHECKBOX_SIZE,
      height: TABLE_CHECKBOX_SIZE,
      boxSizing: "border-box"
    }
  } : isCompanyStandardVariant ? {
    // Match the density and typography used by the Companies table.
    // Page-specific cells still control their content, links, and actions.
    "& .MuiTableHead-root .MuiTableCell-root": {
      px: 0.75,
      py: 0.85,
      color: "#667085",
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.15,
      whiteSpace: "normal",
      verticalAlign: "middle"
    },
    "& .MuiTableHead-root .MuiTableSortLabel-root": {
      lineHeight: 1.15,
      whiteSpace: "normal"
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      px: 0.75,
      py: 0.9,
      color: "#344054",
      fontSize: 14,
      fontWeight: 400,
      verticalAlign: "middle"
    },
    "& .MuiTableBody-root .MuiTableCell-root[data-column-id='actions'] .MuiIconButton-root": {
      width: 30,
      height: 30,
      p: 0.75
    }
  } : {
    "& .MuiTableHead-root .MuiTableCell-root": {
      py: 1.1,
      color: "#667085",
      fontSize: 14,
      fontWeight: 400,
      whiteSpace: "normal"
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      py: 1.1,
      color: "#344054",
      fontSize: 14,
      fontWeight: 400,
      verticalAlign: "middle"
    },
    "& .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root:last-child:has(.MuiIconButton-root)": {
      textAlign: "right"
    }
  }, tableSx || undefined, {
    "& .MuiTableHead-root .MuiTableCell-root, & .MuiTableHead-root .MuiTableSortLabel-root": {
      color: "#344054",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12px !important",
      lineHeight: "20px"
    }
  }],
  selectionColumn: ({
    resolvedSelectionColumnWidth
  }) => ({
    width: resolvedSelectionColumnWidth,
    minWidth: resolvedSelectionColumnWidth,
    maxWidth: resolvedSelectionColumnWidth
  }),
  dataColumn: ({
    col
  }) => ({
    width: col.width,
    minWidth: 0,
    maxWidth: col.maxWidth
  }),
  headerSelection: ({
    headerSelectionCellSx,
    selectionCellSx
  }) => [headerSelectionCellSx, selectionCellSx],
  headerCell: ({
    col,
    isReferenceVariant
  }) => ({
    minWidth: 0,
    width: col.width,
    maxWidth: col.maxWidth,
    overflow: "hidden",
    ...(isReferenceVariant ? {} : {})
  }),
  unsortableLabel: () => ({
    cursor: "default",
    color: "#667085 !important"
  }),
  sortLabel: ({
    col
  }) => ({
    "& .MuiTableSortLabel-icon": {
      opacity: 1,
      height: 16,
      width: 16,
      ...(col.label === "Company Name" ? {
        color: "#9C4FFF !important"
      } : {})
    }
  }),
  bodySelection: ({
    bodySelectionCellSx,
    selectionCellSx
  }) => [bodySelectionCellSx, selectionCellSx],
  emptyState: () => ({
    py: 3
  }),
  bottomBulkActions: ({
    isReferenceVariant,
    bottomBulkActionsWrapperSx
  }) => ({
    px: isReferenceVariant ? 0 : "10px",
    borderTop: isReferenceVariant ? "1px solid #84CAFF" : "none",
    borderBottom: isReferenceVariant ? "1px solid #84CAFF" : "solid 1px #ccc",
    paddingTop: isReferenceVariant ? 0 : "10px",
    paddingBottom: isReferenceVariant ? 0 : "10px",
    ...(bottomBulkActionsWrapperSx || {})
  }),
  paginationBar: ({
    isReferenceVariant,
    paginationBarSx
  }) => isReferenceVariant ? {
    mt: 3.5,
    mb: 0.5,
    ...paginationBarSx,
    display: "grid",
    gridTemplateColumns: "minmax(112px, 1fr) auto minmax(112px, 1fr)",
    alignItems: "center",
    columnGap: 1.25,
    width: "100%",
    minWidth: 0,
    "@media (max-width:600px)": {
      gridTemplateColumns: "minmax(76px, 1fr) minmax(76px, 1fr)",
      "& .prev-btn, & .next-btn": {
        minWidth: 76,
        px: 1.5
      },
      "& .pagination-page-numbers": {
        gridColumn: "1 / -1",
        gridRow: 1,
        justifySelf: "center",
        justifyContent: "center"
      },
      "& .prev-btn": {
        gridColumn: 1,
        gridRow: 2,
        justifySelf: "start"
      },
      "& .next-btn": {
        gridColumn: 2,
        gridRow: 2,
        justifySelf: "end"
      }
    }
  } : {
    ...paginationBarSx,
    display: "grid",
    gridTemplateColumns: "minmax(112px, 1fr) auto minmax(112px, 1fr)",
    alignItems: "center",
    columnGap: 1.25,
    width: "100%",
    minWidth: 0,
    "@media (max-width:600px)": {
      gridTemplateColumns: "minmax(76px, 1fr) minmax(76px, 1fr)",
      "& .prev-btn, & .next-btn": {
        minWidth: 76,
        px: 1.5
      },
      "& .pagination-page-numbers": {
        gridColumn: "1 / -1",
        gridRow: 1,
        justifySelf: "center",
        justifyContent: "center"
      },
      "& .prev-btn": {
        gridColumn: 1,
        gridRow: 2,
        justifySelf: "start"
      },
      "& .next-btn": {
        gridColumn: 2,
        gridRow: 2,
        justifySelf: "end"
      }
    }
  },
  paginationLoading: () => ({
    position: "absolute",
    top: -27,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center"
  }),
  loadingSpinner: () => ({
    color: "#9747FF"
  }),
  previousButton: ({
    isReferenceVariant
  }) => ({
    justifySelf: "start",
    borderRadius: 30,
    px: 2.5,
    py: 0.75,
    minWidth: isReferenceVariant ? 72 : 90,
    touchAction: "manipulation",
    border: "1px solid #9C4FFF",
    backgroundColor: "#9C4FFF",
    color: "#FFFFFF",
    textTransform: "none",
    fontSize: isReferenceVariant ? 10 : 13,
    justifyContent: "flex-start",
    "& .MuiSvgIcon-root": {
      fontSize: 16,
      mr: 0.5
    },
    "&&:hover": {
      backgroundColor: "#FFFFFF !important",
      color: "#9C4FFF !important",
      border: "1px solid #9C4FFF !important",
      borderColor: "#9C4FFF !important",
      outline: "1px solid #9C4FFF !important",
      outlineOffset: "-1px",
      boxShadow: "none !important"
    },
    "&.Mui-disabled": {
      borderColor: "#A2ABB4",
      color: "#A2ABB4",
      backgroundColor: "transparent"
    }
  }),
  pageButton: ({
    isReferenceVariant,
    activePage,
    item
  }) => ({
    minWidth: {
      xs: 32,
      sm: isReferenceVariant ? 26 : 40
    },
    width: {
      xs: 32,
      sm: isReferenceVariant ? 26 : 40
    },
    height: {
      xs: "32px !important",
      sm: isReferenceVariant ? "26px !important" : "40px !important"
    },
    minHeight: {
      xs: "32px !important",
      sm: isReferenceVariant ? "26px !important" : "40px !important"
    },
    maxWidth: {
      xs: 32,
      sm: isReferenceVariant ? 26 : 40
    },
    aspectRatio: "1 / 1",
    flex: "0 0 auto",
    borderRadius: "50%",
    fontSize: isReferenceVariant ? 10.5 : 14,
    textTransform: "none",
    padding: 0,
    touchAction: "manipulation",
    lineHeight: "normal",
    border: activePage === item - 1 ? "1px solid #9747FF !important" : "1px solid transparent !important",
    color: activePage === item - 1 ? "#9747FF" : "#475467",
    backgroundColor: activePage === item - 1 ? "#F9F5FF" : "transparent",
    "&:hover": {
      backgroundColor: "#FFFFFF",
      border: activePage === item - 1 ? "1px solid #9747FF !important" : "1px solid transparent !important",
      borderColor: activePage === item - 1 ? "#9747FF !important" : "transparent !important"
    },
    "&.Mui-disabled": {
      borderColor: "#A2ABB4",
      color: "#A2ABB4"
    }
  }),
  pageEllipsis: ({
    isReferenceVariant
  }) => ({
    width: {
      xs: 32,
      sm: isReferenceVariant ? 26 : 40
    },
    textAlign: "center"
  }),
  nextButton: ({
    isReferenceVariant
  }) => ({
    justifySelf: "end",
    borderRadius: 30,
    px: 2.5,
    py: 0.75,
    minWidth: isReferenceVariant ? 72 : 90,
    touchAction: "manipulation",
    textTransform: "none",
    fontSize: isReferenceVariant ? 10 : 13,
    justifyContent: "flex-end",
    border: "1px solid #9C4FFF",
    backgroundColor: "#9C4FFF",
    color: "#FFFFFF",
    "&&:hover": {
      backgroundColor: "#FFFFFF !important",
      color: "#9C4FFF !important",
      border: "1px solid #9C4FFF !important",
      borderColor: "#9C4FFF !important",
      outline: "1px solid #9C4FFF !important",
      outlineOffset: "-1px",
      boxShadow: "none !important"
    },
    "&.Mui-disabled": {
      backgroundColor: "transparent",
      border: "1px solid #A2ABB4",
      color: "#A2ABB4"
    }
  })
};
